import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AuthPhoneComponent } from './auth-phone.component';
import { ButtonModule } from '@libs/shared/components/button/button.module';
import { PhoneInputDirective } from '@libs/directives/phone-input.directive';

@NgModule({
  declarations: [AuthPhoneComponent],
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, FormsModule, NgxMaskDirective, ButtonModule, PhoneInputDirective],
  providers: [provideNgxMask()],
  exports: [AuthPhoneComponent],
})
export class AuthPhoneModule {}
